var _path, _g, _path2, _g2, _path3, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeslaMotors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1729,
    height: 2500,
    viewBox: "0 0 345.859 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e31937",
    d: "M0 0h345.859v500H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.601 403.28v21.912h7.027v-14.589h25.575v14.589h7.022v-21.874l-39.624-.038M272.845 396.192h27.02c3.753-.746 6.544-4.059 7.331-7.263h-41.681c.779 3.206 3.611 6.517 7.33 7.263"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M245.319 425.206c3.543-1.502 5.449-4.1 6.18-7.141h-31.518l.021-29.117-7.065.02v36.238h32.382M160.398 396.094h24.954c3.762-1.093 6.921-3.959 7.691-7.136h-39.641v21.415h32.444v7.515l-25.449.021c-3.988 1.112-7.37 3.79-9.057 7.327l2.062-.038h39.415v-21.944h-32.42v-7.16",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.795 396.163h27.011c3.758-.749 6.551-4.059 7.334-7.266H91.461c.778 3.207 3.612 6.517 7.334 7.266M98.795 410.485h27.011c3.758-.741 6.551-4.054 7.334-7.263H91.461c.778 3.211 3.612 6.522 7.334 7.263M98.795 425.202h27.011c3.758-.747 6.551-4.059 7.334-7.264H91.461c.778 3.208 3.612 6.517 7.334 7.264"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.524 388.986c.812 3.167 3.555 6.403 7.316 7.215h11.37l.58.229v28.691h7.1V396.43l.646-.229h11.38c3.804-.98 6.486-4.048 7.284-7.215v-.07H28.524v.07",
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.146 317.299l35.477-199.519c33.814 0 44.48 3.708 46.021 18.843 0 0 22.685-8.458 34.125-25.636-44.646-20.688-89.505-21.621-89.505-21.621l-26.176 31.882.059-.004-26.177-31.883s-44.86.934-89.5 21.622c11.431 17.178 34.124 25.636 34.124 25.636 1.549-15.136 12.202-18.844 45.79-18.868l35.762 199.548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.132 80.157c36.09-.276 77.398 5.583 119.687 24.014 5.652-10.173 7.105-14.669 7.105-14.669-46.228-18.289-89.519-24.548-126.797-24.705-37.277.157-80.566 6.417-126.787 24.705 0 0 2.062 5.538 7.1 14.669 42.28-18.431 83.597-24.29 119.688-24.014h.004"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeslaMotors);
export default __webpack_public_path__ + "static/media/Tesla_Motors.a2e6ec2f92532a8fb448cc63a1d2dbb6.svg";
export { ForwardRef as ReactComponent };